import { defineMessages } from 'react-intl-next';

export const i18n: {
	positionFilterTeamLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterTeamPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterTeamLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterTeamLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	positionFilterTeamLabel: {
		id: 'search-page.filters.names.positionTeam',
		defaultMessage: 'Team',
		description: 'Label for filtering by team',
	},
	positionFilterTeamPlaceholder: {
		id: 'search-page.talent.filter.position-team.content.placeholder',
		defaultMessage: 'Find teams',
		description: 'Placeholder for team filter search input',
	},
	positionFilterTeamLabelSelected: {
		id: 'search-page.talent.filter.position-team.content.selected',
		defaultMessage: 'Selected',
		description: 'Team filter content selected',
	},
	positionFilterTeamLabelUnselected: {
		id: 'search-page.talent.filter.position-team.content.unselected',
		defaultMessage: 'Suggested',
		description: 'Team filter content unselected',
	},
});
